import Papa, { UnparseConfig } from "papaparse";

export const downloadCsv = (
  rows: Object[],
  name: string,
  config: UnparseConfig | undefined = { delimiter: "," }
) => {
  const csvContent = Papa.unparse(rows, config);
  downloadFile(csvContent, `${name}.csv`, "text/csv");
};

export const downloadFile = (
  content: BlobPart,
  filename: string,
  type: string
) => {
  const a = document.createElement("a");

  const downloadLink = window.URL.createObjectURL(
    new Blob([content], { type })
  );

  a.href = downloadLink;
  a.download = filename;
  a.click();

  window.URL.revokeObjectURL(downloadLink);
};
